/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-control-statements/jsx-jcs-no-undef */
/* eslint-disable no-console */
/* eslint-disable no-alert */
/* eslint-disable guard-for-in */
/* eslint-disable max-len */
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable jsx-control-statements/jsx-use-if-tag */
/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable no-useless-escape */
/* eslint-disable complexity */
import React, { useState, useRef, useEffect } from 'react'
import { Spacer, Field, Button, Divider, Checkbox } from '@cleartrip/bento'

import { sendClevertapUIActionEvent as ClevertapEvent } from 'AccountsUtils'
import OfflineToast from '../offlineToast'

import { SVGComponent } from '../..'
import USER_PROFILE_PAGE_CONTANTS from '../UserProfileConstants'
import ModalHeader from '../UserProfileModalHeader'
import SkippableBanner from './SkippableBanner'
import SkippableBannerPWA from './SkippableBannerPWA'

const isRtl = process.env.CONTENT_DIR === 'RTL'

function SignInBlock({
  isPwa,
  isFocus,
  animatedClass,
  toggle,
  signInError,
  validateEmailHandler,
  changeEmailHandler,
  isEmailValid,
  email,
  validatePasswordHandler,
  changePasswordHandler,
  isPasswordValid,
  password,
  spanClass,
  checkboxClass,
  rememberCheckedStatus,
  setRememberCheckedStatus,
  checkBoxTextClass,
  onContinue,
  errorInfo,

  pagePath,
  clickHandler,
  handleLinkClick,
  setPageName,
  signInPasswordType,
  setSignInPasswordType,
  isLoading,
  abLogin = 'a'
}) {
  const [isSticky, setSticky] = useState(false)
  const [vheight, setVheight] = useState(window.innerHeight)
  const [isFullHeight, setFullHeight] = useState(false)
  const [loginSwitch, setLoginSwitch] = useState(true)
  const skippableBlock = useRef(null)
  const loginContainer = useRef(null)
  const bannerAnimationRef = useRef()
  const handleScroll = () => {
    if (skippableBlock.current.getBoundingClientRect().top < 10) {
      setFullHeight(true)
    }
    // if (skippableBlock.current?.getBoundingClientRect()?.top < 0 ||
    //   skippableBlock.current?.getBoundingClientRect()?.top === 0) {
    //   setSticky(true)
    // }
  }

  useEffect(() => {
    if (isFocus) {
      setSticky(true)
    }
    if (skippableBlock.current.getBoundingClientRect().top < 10) {
      setFullHeight(true)
    } else {
      // setSticky(false)
      setFullHeight(false)
    }
    document.body.classList.add('o-hidden')

    // let containerHeight = skippableBlock.current
    const updateWindowDimensions = () => {
      const newHeight = window.innerHeight
      setVheight(newHeight)
      loginContainer.current.scrollIntoView({ block: 'center' })
    }

    window.addEventListener('resize', updateWindowDimensions)
    return () => {
      window.removeEventListener('resize', updateWindowDimensions)
      document.body.classList.remove('o-hidden')
    }
  }, [loginSwitch, isFocus, isSticky])

  const handleOnFocus = value => {
    setSticky(true)
  }

  useEffect(() => {
    const OutsideClickHandler = event => {
      if (!bannerAnimationRef.current.contains(event.target)) toggle()
    }
    document.addEventListener('mousedown', OutsideClickHandler)
    return () => {
      document.removeEventListener('mousedown', OutsideClickHandler)
    }
  })

  return (
    <div
      ref={bannerAnimationRef}
      onScroll={handleScroll}
      className={`${isSticky ? 't-0 bg-white' : 'b-0 flex-between '} 
    ${isPwa ?
      'flex flex-column overflow-y-scroll z-2 w-100p p-fixed' :
      ' d-flex '} 
  
        `}
      style={{
        background: isPwa ? '#00000080' : '#ffffff',
        height: isPwa ? vheight : 'auto'
      }}
    >
      {isPwa && (
        <div className="p-sticky t-0 w-100p p-fixed z-20 ">
          {isSticky && (
            <div className="bg-orange-100 bg-white-f7 elevation-lg flex flex-row flex-middle">
              <span className="d-ib px-5  py-4 fs-12 fw-700 c-white" onClick={toggle}>
                <SVGComponent
                  svgIcon="crossDark"
                  height={24}
                  width={24}
                  className="c-pointer c-white"
                />
              </span>
              <span className="d-ib fs-16 fw-600 lh-24 c-black">Sign up / Log in</span>
            </div>
          )}
        </div>
      )}
      <div ref={skippableBlock}>
        {isPwa ? (
          <SkippableBannerPWA isSticky={isSticky} toggle={toggle} abLogin={abLogin} />
        ) : (
          <SkippableBanner abLogin={abLogin} />
        )}
      </div>

      <div
        className={`${animatedClass} d-flex flex-1 flex-column bg-white`}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            onContinue()
          }
        }}
        style={{
          width: isPwa ? 'auto' : '416px',
          height: '437px'
        }}
      >
        {isPwa ? (
          <div className="pt-6" />
        ) : (
          <ModalHeader title="" toggle={toggle} />
        )}

        <div
          className={`${isPwa ? '' : ''}`}
          style={{ maxHeight: isPwa ? 'auto' : '368px' }}
        >
          <OfflineToast page="sign in" />
          {signInError && (
            <>
              <div className="py-2 px-2 h-8 flex flex-middle bg-error-600 c-white fs-2 br-4 ">
                <SVGComponent
                  svgIcon="info_icon"
                  className="c-white"
                  height={16}
                  width={16}
                />
                <span data-testid="signinError" className={errorInfo}>
                  {signInError}
                </span>
              </div>
              <Spacer className="pt-8" />
            </>
          )}

          <Field
            placeholder="Enter registered email address"
            onBlur={validateEmailHandler}
            onChange={changeEmailHandler}
            hasError={!isEmailValid}
            onFocus={handleOnFocus}
            value={email}
            data-testid="email"
          />
          {!isEmailValid && (
            <div
              data-testid="invalidEmailMessage"
              className="c-error-500 fs-2 mt-1"
            >
              {'Please enter a valid email address'}
            </div>
          )}
          <Spacer className="pt-4" />
          <div className="p-relative">
            <Field
              placeholder="Enter password"
              type={signInPasswordType ? 'password' : 'text'}
              onBlur={validatePasswordHandler}
              onChange={changePasswordHandler}
              hasError={!isPasswordValid && password.length === 0}
              value={password}
              data-testid="password"
            />
            {!isPasswordValid &&
              (password.length === 0 && (
                <div
                  data-testid="invalidPassword"
                  className="c-error-500 fs-2 mt-1"
                >
                  {'Password cannot be left blank'}
                </div>
              ))}
            <span
              className={spanClass}
              onClick={() => setSignInPasswordType(!signInPasswordType)}
            >
              {signInPasswordType ? (
                <SVGComponent svgIcon="visibility" />
              ) : (
                <SVGComponent svgIcon="visibility_off" />
              )}
            </span>
          </div>
          <div ref={loginContainer} />

          <Spacer className="pt-3" />
          <div className="p-relative">
            <Checkbox
              className={checkboxClass}
              checked={rememberCheckedStatus}
              onClick={() => setRememberCheckedStatus(!rememberCheckedStatus)}
            >
              <span className={checkBoxTextClass}>Keep me logged in</span>
            </Checkbox>
            <span
              data-testid="forgot"
              onClick={() => {
                ClevertapEvent({
                  actionName: 'forgot_pwd',
                  actionType: 'Button',
                  page: 'flights_sign_in'
                })
                clickHandler(USER_PROFILE_PAGE_CONTANTS.RESET_PAGE, true)
              }}
              className="fs-2 c-secondary-500 c-pointer hover:td-underline p-absolute h-9 flex  r-2 fw-500 t-0"
            >
              {'Forgot password?'}
            </span>
          </div>

          <Spacer className="pt-3" />

          <Spacer className="pt-3" />
          <div className="p-relative">
            <Button
              full={true}
              type="secondary"
              size="md"
              busy={isLoading}
              className="h-10"
              onClick={() => onContinue()}
            >
              <span className="fs-3 fw-550"> {'Log in'}</span>
            </Button>

            <Spacer className="pt-6" />

            <div className="d-flex flex-center flex-middle">
              <div
                className="d-block bb bc-grey-10 flex-1 "
                style={{ maxWidth: '28px' }}
              />
              <p className=" mr-2 ml-2 fs-2  c-grey-40">or</p>
              <div
                className="d-block bb bc-grey-10 flex-1"
                style={{ maxWidth: '28px' }}
              />
            </div>

            <Spacer className="pt-6" />
            <Button
              full={true}
              outline={true}
              type="secondary"
              className="h-10"
              size="md"
              onClick={() => setPageName(USER_PROFILE_PAGE_CONTANTS.SIGNIN)}
            >
              <span className="d-flex flex-middle flex-center">
                <div>
                  <SVGComponent svgIcon="phone" />
                </div>
                <div className="ml-1 fs-3 fw-500">Continue with Mobile</div>
              </span>
            </Button>
          </div>

          <Spacer className="pt-6" />
          <Divider />

          <div className="mt-4 d-flex flex-column flex-middle">
            <div style={{ direction: isRtl ? 'rtl' : '' }}>
              <span className="c-neutral-700 fs-2">
                {"By continuing in, you agree to Cleartrip's "}
              </span>
              <span
                style={isRtl ? { marginRight: '-2px' } : {}}
                className="c-secondary-500 fw-500 fs-2 hover:td-underline c-pointer"
                onClick={() => handleLinkClick('privacy-policy')}
              >
                {'privacy policy'}
              </span>
              <span className="c-neutral-700 fs-2"> & </span>
              <span className="d-flex flex-center ">
                <span
                  className="c-secondary-500 fw-500 fs-2 hover:td-underline c-pointer"
                  onClick={() => handleLinkClick('terms-of-service')}
                >
                  {'terms of use '}
                </span>
                <span className="c-neutral-700 fs-2">.</span>
              </span>
            </div>
          </div>
          <Spacer className="pt-5" />
        </div>
      </div>
    </div>
  )
}

export default SignInBlock
